__turbopack_context__.v({
  "buttonsWrapper": "_6FQ9ga_buttonsWrapper",
  "clearCartButton": "_6FQ9ga_clearCartButton",
});
